import React from 'react';
import { Navigate } from 'react-router-dom';
import { isMobileDevice } from '../utils/mobileDetection';

/**
 * Component that redirects users to the appropriate page based on device type
 * Mobile users are redirected to inventory count history, desktop users to dashboard
 */
const MobileAwareRedirect = () => {
  // Check if user is on mobile device
  const isMobile = isMobileDevice();
  
  // Redirect mobile users to inventory count history, desktop users to dashboard
  return <Navigate to={isMobile ? '/inventory-count-history' : '/dashboard'} replace />;
};

export default MobileAwareRedirect;